module.exports = __webpack_public_path__ + "img/deer-logo.050158b2.svg";